import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SVG = styled.svg`
    display: block;
    width: 100%;
    font-family: ${({ theme }) => theme.fonts.family.primary};
    font-size: ${({ $fontSize }) => $fontSize};
    color: ${({ theme }) => theme.primaryTextColor};
`;

const Container = styled.div`
    height: 100%;
`;

const ScalableText = ({
    fontSize,
    viewBoxWidth,
    viewBoxHeight,
    children,
    ...otherProps
}) => (
    <SVG
        viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
        preserveAspectRatio="xMinYMin meet"
        $fontSize={fontSize}
        {...otherProps}
    >
        <foreignObject width={viewBoxWidth} height={viewBoxHeight} xmlns="http://www.w3.org/1999/xhtml">
            <Container xmlns="http://www.w3.org/1999/xhtml">
                {children}
            </Container>
        </foreignObject>
    </SVG>
);

ScalableText.propTypes = {
    viewBoxWidth: PropTypes.number.isRequired,
    viewBoxHeight: PropTypes.number.isRequired,
    fontSize: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default ScalableText;
